import queryString from 'query-string';

export const isOAuthHeader = () => {
  const paths = ['/app/user/sub-account-login'];
  const path = window.location.pathname;
  const search = queryString.parse(window.location.search);
  const fromOauth = Array.isArray(search.from)
    ? search.from?.includes('oauth')
    : search.from === 'oauth';
  const isOAuth = paths.includes(path) && fromOauth;
  if (isOAuth) {
    document
      .querySelector('#__bybit_uniframe_header__')
      ?.setAttribute('style', 'display: none');
    document.querySelector('body')?.setAttribute('style', 'min-width: auto');
  }
  return isOAuth;
};
